var core = {};
module.exports = core;
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.core.js
 ** module id = 2
 ** module chunks = 0
 **/